import EditableCell from "./EditableCell";
import TableCell from "./TableCell";
import type { SubscriptionTableColumn, SubscriptionTableRow } from "./types";

interface TableRowProps {
    row: SubscriptionTableRow;
    columns: SubscriptionTableColumn[];
    onCellSave?: (rowId: string | number, columnId: string, value: any) => void;
}

const TableRow = ({ row, columns, onCellSave }: TableRowProps) => {
    return (
        <tr>
            {columns.map((column, index) => {
                const value = row[column.id];
                const content = column.render ? column.render(value, row) : value;
                const isFirst = index === 0;
                const isLast = index === columns.length - 1;
                const cellStyle = {
                    paddingLeft: isFirst ? "16px" : "8px",
                    paddingRight: isLast ? "16px" : "8px",
                };

                if (column.editable) {
                    return (
                        <EditableCell
                            key={column.id}
                            value={value}
                            rowId={row.id}
                            columnId={column.id}
                            onSave={onCellSave}
                            highlighted={column.highlighted}
                            align={column.align}
                            width={column.width}
                            style={cellStyle}
                        />
                    );
                }

                return (
                    <TableCell
                        key={column.id}
                        highlighted={column.highlighted}
                        align={column.align}
                        width={column.width}
                        style={cellStyle}
                    >
                        {content}
                    </TableCell>
                );
            })}
        </tr>
    );
};

export default TableRow;
